import React from "react";
import {
  List,
  ListItem,
  ListItemText,
  Typography,
  Box,
  Paper,
  Avatar,
} from "@mui/material";
import { styled } from "@mui/system";
import ShoppingBasketIcon from "@mui/icons-material/ShoppingBasket";
import { Link } from "react-router-dom";
import PersonIcon from "@mui/icons-material/Person";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import FolderSharedIcon from "@mui/icons-material/FolderShared";
import PowerSettingsNewIcon from "@mui/icons-material/PowerSettingsNew";
import KeyboardArrowRightOutlinedIcon from "@mui/icons-material/KeyboardArrowRightOutlined";

const SidebarContainer = styled(Box)({
  width: "213px",
  backgroundColor: "#eef2f6",
  height: "100vh",
  boxShadow: "3px 0 5px rgba(0,0,0,0.1)",
});

const Sidebar = () => {
  return (
    <SidebarContainer sx={{ marginTop: 3 }}>
      <Paper sx={{ borderRadius: "1px" }}>
        <Box sx={{ display: "flex", padding: 1 }}>
          <Avatar src="" />
          <Link>
            <Typography
              variant="h4"
              gutterBottom
              sx={{ marginLeft: 2, marginTop: 1 }}
            >
              Hello
            </Typography>
          </Link>
        </Box>
      </Paper>
      <Paper sx={{ borderRadius: "1px", marginTop: 2, padding: 1 }}>
        <Box sx={{ display: "flex" }}>
          <ShoppingBasketIcon />
          <Link component={Link} to="/productlisting">
            <Typography variant="h5" sx={{ marginLeft: 2, marginTop: "4px" }}>
              MY ORDERS
            </Typography>
          </Link>
          <KeyboardArrowRightOutlinedIcon sx={{ marginLeft: 4 }} />
        </Box>
      </Paper>
      <List component="nav">
        <Paper sx={{ borderRadius: "1px", padding: 1 }}>
          <Box sx={{ display: "flex" }}>
            <PersonIcon />
            <Typography variant="h5" sx={{ marginLeft: 1, marginTop: "3px" }}>
              ACCOUNT SETTINGS
            </Typography>
          </Box>
          <Box sx={{ marginLeft: 2, marginTop: 1 }}>
            <Link component={Link} to="/myprofile">
              <ListItem button>
                <ListItemText primary="Profile Information" />
              </ListItem>
            </Link>
            <Link component={Link} to="/myaddress">
              <ListItem button>
                <ListItemText primary="Manage Addresses" />
              </ListItem>
            </Link>
            <ListItem button>
              <ListItemText primary="PAN Card Information" />
            </ListItem>
          </Box>
        </Paper>
        <Paper sx={{ borderRadius: "1px", padding: 1, marginTop: 1 }}>
          <Box sx={{ display: "flex" }}>
            <AccountBalanceWalletIcon />
            <Typography variant="h5" sx={{ marginLeft: 1, marginTop: "3px" }}>
              PAYMENTS
            </Typography>
          </Box>
          <Box sx={{ marginLeft: 2, marginTop: 1 }}>
            <ListItem button>
              <ListItemText primary="Gift Cards" />
            </ListItem>
            <ListItem button>
              <ListItemText primary="Saved UPI" />
            </ListItem>
            <ListItem button>
              <ListItemText primary="Saved Cards" />
            </ListItem>
          </Box>
        </Paper>
        <Paper sx={{ borderRadius: "1px", padding: 1, marginTop: 1 }}>
          <Box sx={{ display: "flex" }}>
            <FolderSharedIcon />
            <Typography variant="h5" sx={{ marginLeft: 1, marginTop: "3px" }}>
              MY STUFF
            </Typography>
          </Box>
          <Box sx={{ marginLeft: 2, marginTop: 1 }}>
            <ListItem button>
              <ListItemText primary="My Coupons" />
            </ListItem>
            <ListItem button>
              <ListItemText primary="My Reviews & Ratings" />
            </ListItem>
            <ListItem button>
              <ListItemText primary="All Notifications" />
            </ListItem>
            <ListItem button component={Link} to="/wishlist">
              <ListItemText primary="My Wishlist" />
            </ListItem>
          </Box>
        </Paper>
        <Paper sx={{ borderRadius: "1px", padding: 1, marginTop: 1 }}>
          <Box sx={{ display: "flex" }}>
            <PowerSettingsNewIcon />
            <Link>
              <Typography variant="h5" sx={{ marginLeft: 1, marginTop: "3px" }}>
                Logout
              </Typography>
            </Link>
          </Box>
        </Paper>
        <Paper sx={{ borderRadius: "1px", padding: 1, marginTop: 2 }}>
          <Typography variant="h5" sx={{ marginLeft: 1, marginTop: "3px" }}>
            Frequently Visited:
          </Typography>
          <Box sx={{ display: "flex", marginTop: 1, marginLeft: 1 }}>
            <Link>
              <Typography sx={{ color: "grey" }}>Track Order</Typography>
            </Link>
            <Link>
              <Typography sx={{ marginLeft: 1, color: "grey" }}>
                Help Center
              </Typography>
            </Link>
          </Box>
        </Paper>
      </List>
    </SidebarContainer>
  );
};

export default Sidebar;
